module.exports = __webpack_public_path__ + "img/Laptop.9475ebae.png";